exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toggle-el[data-v-160d6ae3] {\n  display: none;\n}\n.container-align[data-v-160d6ae3] {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n", ""]);

// exports
